<template>
  <m-geo-box geo-option="SCFCode" :need-next="true" @go="goNext">
    <m-s-c-f-code :geoType="8" :is-go.sync="isGo"></m-s-c-f-code>
  </m-geo-box>
</template>

<script>
  import MGeoBox from '@/components/geo/MGeoBox'
  import MSCFCode from '@/components/geo/MSCFCode'

  export default {
    components: {
      MGeoBox,
      MSCFCode
    },
    data () {
      return {
        isGo: false
      }
    },
    methods: {
      goNext () {
        this.isGo = true
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/order/GeoSCFCode.vue